var modules_c7892e2f = {"root":"CardIcon_module_root__92956752","size-s":"CardIcon_module_sizeS__92956752","size-m":"CardIcon_module_sizeM__92956752","size-l":"CardIcon_module_sizeL__92956752","transparent":"CardIcon_module_transparent__92956752"};
import "../../../../assets/esm/components/OfferCard/components/CardIcon/CardIcon~BnhVMnR1.css";

export { modules_c7892e2f as default };
//# sourceMappingURL=CardIcon.module.scss.js.map
